module.exports = __webpack_public_path__ + "static/media/Team 41 - Surfer 6.e8378c00.png";